import React from "react";
import "./AboutPage.css";

export default function AboutPage() {
  return <div>AboutPage</div>;
}
